import React, {useEffect, useState} from 'react';
import { useLocation,useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid,Box } from '@mui/material';
import { getServiceCity } from 'redux/actions/UserServiceCity';
import { debounce } from "lodash";
import CommonTable from 'components/commonTable/CommonTable';
import { getVendor, patchUpdateVendor, postAddVendor } from 'redux/actions/UserVendor';
import Loader from 'components/loader/Loader';
import { filterdata, moreIconData, vendorDialogData } from './VendorBreadCrumbData';
import CommonDialog from 'components/commonDialog/CommonDialog';
import CommonSDF from "components/commonSDF/CommonSdf";


function Vendor() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const TableData = useSelector((state) => state?.userVendor?.userVendor?.data);
  const loader = useSelector((state) => state?.userVendor?.loading);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [status, setStatus] = useState("");
  const [open, setOpen] = useState(false);
  const [type, setType] = useState('Edit');
  const [id, setId] = useState(null);
  const [defaultValue, setDefaultValue] = useState({})
  const [filterLocation, setFilterLocation] = useState("")
  const [search, setSearch] = useState("");
  const locationList = useSelector((state) => state?.userServiceCity?.userServiceCity?.data);
  const locationOption = locationList?.map((val, idx) => {
    return { value: val?.id, label: val?.name };
  });
  let filterData = {
    id: "",
    page:page,
    dateFrom:dateFrom,
    dateTo:dateTo,
    status:status,
    location: filterLocation,
    pageSize:rowsPerPage,
    search: search,
  }

  useEffect(() => {
    dispatch(getVendor(filterData));
    dispatch(getServiceCity());
  }, []);

  const handleChangePage = (event,newPage) =>{
    setPage(newPage)
    dispatch(getVendor({...filterData, page:newPage}))
  }

  const handleChangeRowsPerPage = (event) =>{
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(getVendor({...filterData, page:0, pageSize:parseInt(event.target.value)}))
  }

  const onFilterChange = (val) => {
    const defaultStatus = ['Active', 'InActive', 'Blocked', 'Pending', "Rejected"];

    const filterLocations = val.filter(location => {
      return !defaultStatus.includes(location);
    });
    
    const filterStatus = val.filter(status => {
      return defaultStatus.includes(status);
    });

    setStatus(filterStatus)
    setFilterLocation(filterLocations)
    filterData = {...filterData, status:filterStatus?.toString(), location:filterLocations?.toString()}
    dispatch(getVendor(filterData))
  }

  
  const onRestFilter = () => {
    setStatus("")
    filterData = {...filterData, status:""}
    dispatch(getVendor(filterData));
  }

  const onSearch = debounce((e) => {
    setSearch(e);
    setPage(0);
      const searchFilterData = {
        ...filterData,
        search: e,
        page: 0,
      };
      dispatch(getVendor(searchFilterData));
  }, 1000);

  const onClickTableVendor = (val) => {
    let url = location.pathname.split("/")[1]
    if (url === 'vendor'){
      // navigate(`/vendor/details?id=${val.id}&&status=${val?.status}&&name=${val?.companyName}&&companyId=${val?.id}`)
      navigate(`/vendor/${val?.location}/${'1'}`, { state: { id: val?.id, status: val?.status, name:val?.companyName, companyId:val?.id, cityLocation:val?.location, cityLocationId:val?.locationId } })
    }
  }

  const onSubmit = (val, code) => {
    const data = {
      mobile:val.number,
      firstName:val?.vendorName.trim(),
      lastName:"",
      email:val.email,
      countryCode:code,
      companyName:val?.vendorName.trim(),
      location: val?.city,
    }
    dispatch(postAddVendor(data))
  }

  const onClickMoreIcon = (data, type) => {
    const value = {
      vendorName: data?.companyName.trim(),
      email: data?.email,
      number: data?.mobile,
      // address: data?.address,
      city: data?.location,
      // state: data?.state
    }
    setDefaultValue(value)
    setId(data.id)
    if(type === 'Delete'){
      
    }else if(type === 'Edit') {
      setType(type)
      setOpen(true);
    }else if(type === 'Deactivate') {
      const profileData = {
        vendorId:data.id,
        data:{
          status:'InActive'
        }
      }
      dispatch(patchUpdateVendor(profileData));
    }else if(type === 'Activate') {
      const profileData = {
        vendorId:data.id,
        data:{
          status:'Active'
        }
      }
      dispatch(patchUpdateVendor(profileData));
    }else if(type === 'Block') {
      const profileData = {
        vendorId:data.id,
        data:{
          status:'Blocked'
        }
      }
      dispatch(patchUpdateVendor(profileData));
    }else if(type === 'Unblock') {
      const profileData = {
        vendorId:data.id,
        data:{
          status:'Active'
        }
      }
      dispatch(patchUpdateVendor(profileData));
    }
    
    
  }

  const onDialog = (data, code) => {
    
    const profileData = {
      vendorId:id,
      data:{
        "firstName":data?.vendorName,
        "lastName":"",
        "email":data?.email,
        "countryCode":"+91",
        "mobile":data?.number,
        "companyName":data?.vendorName.trim(),
        "location":data?.location,
      }
    }
    dispatch(patchUpdateVendor(profileData));
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  }

  return (
    <div className='marginTop25'>
      {/* <VendorBreadCrumb 
        onSubmittBtn={onSubmit} 
        filterdata={filterdata} 
        onSelectDateRange={onSelectDateRange}
        onFilterChange={onFilterChange}
        onRestFilter={onRestFilter}
        locationOption={locationOption}
      /> */}
       <Grid container xs={12} sm={8} md={12} justifyContent={'flex-end'} className='marginBlock12'>
        
      <Grid item xs={12} md={4} className='mr10'>
      {/* <SearchBar
        onSearch={onSearch}
        search={search}
      /> */}
       <Box sx={{
          flex: 1,
          display: 'flex',
          marginTop: { xs: "5px",sm: "10px",md: "10px",lg: "10px" } 
        }}>
          <CommonSDF
           onSearch={onSearch} 
           search={search}
          />
        </Box>
      </Grid>
      </Grid>
      {loader? 
        <Loader/> 
        :
        <CommonTable 
          data={TableData} 
          onClickTableVendor={onClickTableVendor} 
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          page={page}
          rowsPerPage={rowsPerPage}
          // moreIconData={moreIconData}
          onClickMoreIcon={onClickMoreIcon}
          isClickable = {true}
        />
      }
      {open ?<CommonDialog
            open={open}
            handleClose={handleClose}
            formData={vendorDialogData(locationOption)}
            button={'dialogButton'}
            onSubmittBtn={onDialog}
            type={'Edit '+ 'City Manager'+" "}
            selectType={'edit'}
            defaultValues={defaultValue}
          />: null} 
    </div>
  );
}

export default Vendor;
